export class DeleteUserAdditionalEmailSuccess {
    static readonly type = '[User] DeleteUserAdditionalEmailSuccess';

    constructor(public payload: string) {}
}
